/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  TextField, Typography, Grid, InputAdornment,
} from '@material-ui/core';
import AccessTime from '@material-ui/icons/AccessTime';
import PropTypes from 'prop-types';
import { resourceFormStyle } from '../../css/style';
import {
  validationErrorMessages,
  MAX_CHAR_DESCRIBE_TEXTFIELD,
} from '../../data/Constants';

const styles = resourceFormStyle();
class OrderTimingTextField extends Component {
  validateInput = ({ newValue }) => {
    const { field, customValidator } = this.props;
    const { isRequired } = field;
    const { isRequiredError } = validationErrorMessages.field;
    let errorMsg = '';
    if (isRequired && !newValue) {
      errorMsg = isRequiredError;
    }
    if (customValidator) {
      errorMsg = customValidator({ newValue });
    }
    return errorMsg;
  }

  onChangeInput = (event) => {
    const { handleValueChange, field } = this.props;
    const { key } = field;
    const newValue = event.target.value;
    const errorMsg = this.validateInput({ newValue });
    handleValueChange({ key, newValue, errorMsg });
  }

  render() {
    const { field } = this.props;
    const {
      key,
      title,
      errorMessage,
      isValid,
      value,
    } = field;
    const { normalInputPropStyleTiming } = styles;
    return (
      <Grid
        item
        key={field.key}
        xs={field.gridWidth ? parseInt(field.gridWidth, 10) : 'auto'}
        style={styles.gridItemColumn}
      >
        <div>
          <div style={styles.itemTitleContainerColumn}>
            <Typography style={styles.itemTitleColumn}>{`${title}:`}</Typography>
            <React.Fragment>
                <TextField
                    key={key}
                    id={key}
                    value={value}
                    onChange={this.onChangeInput}
                    margin="dense"
                    style={isValid ? styles.textFieldStyleColumn : styles.errorTextFieldStyleColumn }
                    inputProps={{ 
                        ...normalInputPropStyleTiming,
                        maxLength: MAX_CHAR_DESCRIBE_TEXTFIELD,
                    }}
                    InputProps={{ 
                        disableUnderline: true,
                        startAdornment: (
                            <InputAdornment position="start">
                              <AccessTime style={{marginLeft: '10px'}}/>
                            </InputAdornment>
                        ),
                    }}
                />
                <Typography style={styles.errorMessageStyle}>
                    {errorMessage}
                </Typography>
            </React.Fragment>
          </div>
        </div>
      </Grid>
    );
  }
}

OrderTimingTextField.propTypes = {
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  handleValueChange: PropTypes.func.isRequired,
  customValidator: PropTypes.func,
};

OrderTimingTextField.defaultProps = {
  customValidator: null,
};

export default OrderTimingTextField;
